import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import dateToHumanFormat from '@sdk/utils/dateFormat/dateToHumanFormat';
import dateToWeekday from '@sdk/utils/dateFormat/dateToWeekday';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import ModalRow from '@web/timeClock/modals/rows/ModalRow/ModalRow';
import DateIconSvg from '@web/assets/svg/Icons/32/date-gray.svg';

type Props = {
  date: Date;
};

const DateRow = ({ date }: Props) => (
  <ModalRow label={gettext('Date')} icon={DateIconSvg}>
    <Text14 themeColor={ThemeColorType.gray}>
      {dateToWeekday(date)}, {dateToHumanFormat(date, false)}
    </Text14>
  </ModalRow>
);

export default DateRow;
